import { RootState } from "store/store";
import { StateFn } from "store/types";

import { CollectionStatusState } from "./collectionStatusStore";
import { AutomatedCollectionTab } from "./types";

const getStore = (state: RootState): CollectionStatusState =>
  state.collectionStatus;

// Selectors

const automatedCollectionTab: StateFn<AutomatedCollectionTab> = (
  state: RootState
) => getStore(state).automatedCollectionTab;

const isUtilityConnectionsVisible: StateFn<boolean> = (state: RootState) =>
  getStore(state).isUtilityConnectionsVisible;

const entityFilter: StateFn<string[]> = (state: RootState) =>
  getStore(state).entityFilter;

const utilityProviderFilter: StateFn<string[]> = (state: RootState) =>
  getStore(state).utilityProviderFilter;

const activityFilter: StateFn<string[]> = (state: RootState) =>
  getStore(state).activityFilter;

export const collectionStatusSelectors = {
  automatedCollectionTab,
  isUtilityConnectionsVisible,
  entityFilter,
  utilityProviderFilter,
  activityFilter,
};
